<template>
  <div class="py-4 container-fluid">
    <div class="alert alert-warning text-white text-sm" v-if="unmapped.length > 0">
      <i class="fa fa-exclamation-triangle"></i> Akun belum di-mapping ke COA: <b>{{ unmapped.join('; ') }}</b>.
      <router-link to="/acc-setting" class="text-white font-weight-bold"><u>Lengkapi di Setting Akuntansi</u></router-link>
    </div>

    <div class="card">
      <div class="row">
        <div class="col-lg-3">
          <div class="card-header pb-0">
            <h6>Jurnal Otomatis</h6>
            <p class="text-xs mb-0">Dari penerimaan barang, faktur vendor, dan pembayaran.</p>
          </div>
        </div>
        <div class="col-lg-2"><label class="form-control-label mt-2 mb-0 text-xs">Dari</label><input type="date" class="form-control" v-model="search.start" @change="get()"></div>
        <div class="col-lg-2"><label class="form-control-label mt-2 mb-0 text-xs">Sampai</label><input type="date" class="form-control" v-model="search.end" @change="get()"></div>
        <div class="col-lg-2">
          <label class="form-control-label mt-2 mb-0 text-xs">Sumber</label>
          <select class="form-select" v-model="search.source_type" @change="get()">
            <option value="">Semua</option>
            <option value="GR">Penerimaan Barang</option>
            <option value="INVOICE">Faktur Vendor</option>
            <option value="PAYMENT">Pembayaran</option>
          </select>
        </div>
        <div class="col-lg-3">
          <div class="form-check mt-2">
            <input class="form-check-input" type="checkbox" id="incomplete" v-model="search.incomplete" @change="get()">
            <label class="form-check-label text-xs" for="incomplete">Hanya yang akunnya belum lengkap</label>
          </div>
          <argon-button variant="gradient" color="success" size="sm" @click="exportCsv()"><i class="fa fa-file-excel-o"></i> Export (Accurate)</argon-button>
        </div>
      </div>

      <div class="card-body px-0 pt-0 pb-2 mt-3">
        <div class="table-responsive p-0 scroll">
          <table class="table align-items-center mb-0">
            <thead>
              <tr>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder">Tanggal / No. Bukti</th>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder">Akun</th>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder text-end">Debit</th>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder text-end">Kredit</th>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder">Proyek / PO</th>
              </tr>
            </thead>
            <tbody v-for="(journal, i) in table.data" :key="i" style="border-top: 2px solid #dee2e6;">
              <tr>
                <td colspan="5" class="text-xs bg-light">
                  <b>{{ moment(journal.journal_date).locale('id').format('ll') }}</b> &middot; {{ journal.source_type }}-{{ journal.source_id }} &middot; {{ journal.description }}
                  <span class="badge badge-sm bg-gradient-danger ms-2" v-if="!journal.is_complete">Akun belum lengkap</span>
                </td>
              </tr>
              <tr v-for="(line, k) in journal.lines" :key="'l'+k">
                <td></td>
                <td :class="'text-xs '+(Number(line.credit) > 0 ? 'ps-5' : '')">
                  <span v-if="line.account_code"><b>{{ line.account_code }}</b> {{ line.account_name }}</span>
                  <span class="text-danger" v-else>(belum mapping) {{ line.map_description }}</span>
                  <span class="text-xxs text-secondary" v-if="line.memo"><br>{{ line.memo }}</span>
                </td>
                <td class="text-xs text-end">{{ Number(line.debit) > 0 ? num(line.debit) : '' }}</td>
                <td class="text-xs text-end">{{ Number(line.credit) > 0 ? num(line.credit) : '' }}</td>
                <td class="text-xs">{{ line.wo_code }} {{ line.po_no }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="card-footer">
        <div class="float-left">TOTAL JURNAL : {{ table.data.length }}</div>
        <div class="float-right">
          <base-pagination :page-count="pagination.page_count" :value="pagination.page" @input="changePage" :total="pagination.page_count" class="justify-content-end"></base-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import BasePagination from "@/components/BasePagination";
import Api from '@/helpers/api';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
var moment = require('moment');
import accounting from '@/services/accounting/accounting.service';

export default {
  name: "AccJournal",
  components: { ArgonButton, BasePagination },
  data() {
    return {
      moment: moment,
      pagination: { page_count: '', page: 1 },
      table: { data: [] },
      unmapped: [],
      search: { start: moment().startOf('month').format('YYYY-MM-DD'), end: moment().endOf('month').format('YYYY-MM-DD'), source_type: '', incomplete: false },
    };
  },
  mounted() {
    this.get();
  },
  methods: {
    num(value) {
      return Number(value || 0).toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    },
    params() {
      return {
        date:        (this.search.start && this.search.end) ? this.search.start+' to '+this.search.end : '',
        source_type: this.search.source_type,
        incomplete:  this.search.incomplete ? 1 : '',
      };
    },
    get() {
      let context = this;
      Api(context, accounting.journals(Object.assign(context.params(), { page: context.pagination.page }))).onSuccess(function(response) {
          context.table.data            = response.data.data.data.data;
          context.pagination.page_count = response.data.data.data.last_page;
          context.unmapped              = response.data.data.unmapped;
      }).onError(function() {
          toast.error('Data Retrieved Failed', { position: toast.POSITION.BOTTOM_RIGHT, autoClose: 3000 });
      })
      .call()
    },
    exportCsv() {
      let context = this;
      Api(context, accounting.exportJournals(context.params())).onSuccess(function(response) {
          let link = document.createElement('a');
          link.href = URL.createObjectURL(response.data);
          link.download = 'jurnal_'+context.search.start+'_'+context.search.end+'.csv';
          link.click();
          URL.revokeObjectURL(link.href);
      }).onError(function() {
          toast.error('Export Gagal', { position: toast.POSITION.BOTTOM_RIGHT, autoClose: 3000 });
      })
      .call()
    },
    changePage(page) {
      this.pagination.page = page;
      this.get();
    },
  }
};
</script>

<style scoped>
.scroll {
  overflow: auto;
  height: 620px;
}
.scroll thead th {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: #F0F8FF;
}
</style>
